import React, {useRef, useEffect} from 'react'
import PropTypes from 'prop-types'
import "./Section.scss"
import { bem } from '../../helpers'

export const Section = props => {

  const {
    children,
    title,
    orientation,
    numItemsWide,
    numItemsHigh,
    className,
    gap,
    wrap,
    style
  } = props

  const sectionRef = useRef()

  useEffect(() => {
    if(sectionRef?.current){
      if (numItemsWide) { sectionRef.current.style.setProperty('--num-wide', numItemsWide)}
      if (numItemsHigh) { sectionRef.current.style.setProperty('--num-high', numItemsHigh)}
    }
  }, [sectionRef?.current, numItemsWide])

  return (
    <section
      style={style}
      num-wide={numItemsWide || null}
      num-high={numItemsHigh || null}
      className={bem(
        "section",
        null,
        [
          orientation,
          gap && "gap",
          (wrap || numItemsWide || numItemsHigh) && "wrap"
        ],
        className
      )}
    >
      {title}
      <div className={bem("section", "content")} ref={sectionRef}>
        {children}
      </div>
    </section>
  )
}

Section.propTypes = {
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  numItemsWide: PropTypes.number,
  numItemsHigh: PropTypes.number,
  gap: PropTypes.bool,
  className: PropTypes.string,
  wrap: PropTypes.bool
}

Section.defaultProps = {
  numItemsWide: null,
  numItemsHigh: null,
  orientation: "horizontal",
  gap: null,
  wrap: null
}

export default Section
